{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "ਪੇਸਟ ਕਰੋ",
    "pasteAsPlaintext": "ਸਾਦੇ ਪਾਠ ਵਜੋਂ ਪੇਸਟ ਕਰੋ",
    "pasteCharts": "ਚਾਰਟ ਪੇਸਟ ਕਰੋ",
    "chartType_bar": "",
    "chartType_line": "",
    "chartType_radar": "",
    "chartType_plaintext": "",
    "selectAll": "ਸਾਰੇ ਚੁਣੋ",
    "multiSelect": "ਐਲੀਮੈਂਟ ਨੂੰ ਚੋਣ ਵਿੱਚ ਜੋੜੋ",
    "moveCanvas": "ਕੈਨਵਸ ਹਿਲਾਓ",
    "cut": "ਕੱਟੋ",
    "copy": "ਕਾਪੀ ਕਰੋ",
    "copyAsPng": "ਕਲਿੱਪਬੋਰਡ 'ਤੇ PNG ਵਜੋਂ ਕਾਪੀ ਕਰੋ",
    "copyAsSvg": "ਕਲਿੱਪਬੋਰਡ 'ਤੇ SVG ਵਜੋਂ ਕਾਪੀ ਕਰੋ",
    "copyText": "ਕਲਿੱਪਬੋਰਡ 'ਤੇ ਪਾਠ ਵਜੋਂ ਕਾਪੀ ਕਰੋ",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "ਅੱਗੇ ਲਿਆਓ",
    "sendToBack": "ਸਭ ਤੋਂ ਪਿੱਛੇ ਭੇਜੋ",
    "bringToFront": "ਸਭ ਤੋਂ ਅੱਗੇ ਲਿਆਓ",
    "sendBackward": "ਪਿੱਛੇ ਭੇਜੋ",
    "delete": "ਮਿਟਾਓ",
    "copyStyles": "ਸਟਾਇਲ ਕਾਪੀ ਕਰੋ",
    "pasteStyles": "ਸਟਾਇਲ ਪੇਸਟ ਕਰੋ",
    "stroke": "ਰੇਖਾ",
    "changeStroke": "",
    "background": "ਬੈਕਗਰਾਉਂਡ",
    "changeBackground": "",
    "fill": "ਭਰਨਾ",
    "strokeWidth": "ਰੇਖਾ ਦੀ ਚੌੜਾਈ",
    "strokeStyle": "ਰੇਖਾ ਦਾ ਸਟਾਇਲ",
    "strokeStyle_solid": "ਠੋਸ",
    "strokeStyle_dashed": "ਡੈਸ਼ ਵਾਲੀ",
    "strokeStyle_dotted": "ਬਿੰਦੀਆਂ ਵਾਲੀ",
    "sloppiness": "ਬੇਤਰਤੀਬੀ",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "ਅਪਾਰਦਰਸ਼ਤਾ",
    "textAlign": "ਲਿਖਤ ਇਕਸਾਰਤਾ",
    "edges": "ਕਿਨਾਰੇ",
    "sharp": "ਤਿੱਖੇ",
    "round": "ਗੋਲ",
    "arrowheads": "ਤੀਰ ਦੇ ਸਿਰੇ",
    "arrowhead_none": "ਕੋਈ ਨਹੀਂ",
    "arrowhead_arrow": "ਤੀਰ",
    "arrowhead_bar": "ਡੰਡੀ",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "ਤਿਕੋਣ",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "arrowhead_cardinality_one": "",
    "arrowhead_cardinality_many": "",
    "arrowhead_cardinality_one_or_many": "",
    "arrowhead_cardinality_exactly_one": "",
    "arrowhead_cardinality_zero_or_one": "",
    "arrowhead_cardinality_zero_or_many": "",
    "more_options": "",
    "cardinality": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "ਫੌਂਟ ਅਕਾਰ",
    "fontFamily": "ਫੌਂਟ ਪਰਿਵਾਰ",
    "addWatermark": "\"Excalidraw ਨਾਲ ਬਣਾਇਆ\" ਜੋੜੋ",
    "handDrawn": "ਹੱਥਲਿਖਤ",
    "normal": "ਆਮ",
    "code": "ਕੋਡ",
    "small": "ਛੋਟਾ",
    "medium": "ਮੱਧਮ",
    "large": "ਵੱਡਾ",
    "veryLarge": "ਬਹੁਤ ਵੱਡਾ",
    "solid": "ਠੋਸ",
    "hachure": "ਤਿਰਛੀਆਂ ਗਰਿੱਲਾਂ",
    "zigzag": "ਵਿੰਗ-ਤੜਿੰਗ",
    "crossHatch": "ਜਾਲੀ",
    "thin": "ਪਤਲੀ",
    "bold": "ਮੋਟੀ",
    "left": "ਖੱਬੇ",
    "center": "ਵਿਚਕਾਰ",
    "right": "ਸੱਜੇ",
    "extraBold": "ਬਹੁਤ ਮੋਟੀ",
    "architect": "ਭਵਨ ਨਿਰਮਾਣਕਾਰੀ",
    "artist": "ਕਲਾਕਾਰ",
    "cartoonist": "ਕਾਰਟੂਨਿਸਟ",
    "fileTitle": "ਫਾਈਲ ਦਾ ਨਾਂ",
    "colorPicker": "ਰੰਗ ਚੋਣਕਾਰ",
    "canvasColors": "ਕੈਨਵਸ 'ਤੇ ਵਰਤਿਆ",
    "canvasBackground": "ਕੈਨਵਸ ਦਾ ਬੈਕਗਰਾਉਂਡ",
    "drawingCanvas": "ਡਰਾਇੰਗ ਕੈਨਵਸ",
    "clearCanvas": "",
    "layers": "ਪਰਤਾਂ",
    "actions": "ਕਾਰਵਾਈਆਂ",
    "language": "ਭਾਸ਼ਾ",
    "liveCollaboration": "ਲਾਇਵ ਸਹਿਯੋਗ...",
    "duplicateSelection": "ਡੁਪਲੀਕੇਟ ਬਣਾਓ",
    "untitled": "ਬੇ-ਸਿਰਨਾਵਾਂ",
    "name": "ਨਾਂ",
    "yourName": "ਤੁਹਾਡਾ ਨਾਂ",
    "madeWithExcalidraw": "Excalidraw ਨਾਲ ਬਣਾਇਆ",
    "group": "ਚੋਣ ਦਾ ਗਰੁੱਪ ਬਣਾਓ",
    "ungroup": "ਚੋਣ ਦਾ ਗਰੁੱਪ ਤੋੜੋ",
    "collaborators": "ਸਹਿਯੋਗੀ",
    "you": "",
    "toggleGrid": "",
    "loadingScene": "ਦ੍ਰਿਸ਼ ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ…",
    "loadScene": "",
    "align": "ਇਕਸਾਰ",
    "alignTop": "ਉੱਪਰ ਇਕਸਾਰ ਕਰੋ",
    "alignBottom": "ਹੇਠਾਂ ਇਕਸਾਰ ਕਰੋ",
    "alignLeft": "ਖੱਬੇ ਇਕਸਾਰ ਕਰੋ",
    "alignRight": "ਸੱਜੇ ਇਕਸਾਰ ਕਰੋ",
    "centerVertically": "ਲੇਟਵੇਂ ਵਿਚਕਾਰ ਕਰੋ",
    "centerHorizontally": "ਖੜ੍ਹਵੇਂ ਵਿਚਕਾਰ ਕਰੋ",
    "distributeHorizontally": "ਖੜ੍ਹਵੇਂ ਇਕਸਾਰ ਵੰਡੋ",
    "distributeVertically": "ਲੇਟਵੇਂ ਇਕਸਾਰ ਵੰਡੋ",
    "flipHorizontal": "ਲੇਟਵੇਂ ਪਾਸੇ ਪਲਟੋ",
    "flipVertical": "ਖੜ੍ਹਵੇਂ ਪਾਸੇ ਪਲਟੋ",
    "viewMode": "ਦੇਖਣ ਵਾਲਾ ਮੋਡ",
    "share": "ਸਾਂਝਾ ਕਰੋ",
    "showStroke": "ਰੇਖਾ ਦਾ ਰੰਗ ਚੋਣਕਾਰ ਦਿਖਾਓ",
    "showBackground": "ਬੈਕਗਰਾਉਂਡ ਦਾ ਰੰਗ ਚੋਣਕਾਰ ਦਿਖਾਓ",
    "showFonts": "",
    "toggleTheme": "",
    "theme": "",
    "decreaseFontSize": "ਫੌਂਟ ਦਾ ਅਕਾਰ ਘਟਾਓ",
    "increaseFontSize": "ਫੌਂਟ ਦਾ ਅਕਾਰ ਵਧਾਓ",
    "unbindText": "ਪਾਠ ਨੂੰ ਵੱਖ ਕਰੋ",
    "bindText": "ਪਾਠ ਨੂੰ ਕੰਟੇਨਰ ਨਾਲ ਬੰਨ੍ਹੋ",
    "createContainerFromText": "ਪਾਠ ਨੂੰ ਕੰਟੇਨਰ ਵਿੱਚ ਇਕੱਠਾ ਕਰੋ",
    "link": {
      "edit": "ਕੜੀ ਸੋਧੋ",
      "editEmbed": "",
      "create": "",
      "label": "ਕੜੀ",
      "labelEmbed": "",
      "empty": "",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "ਪੰਕਤੀ ਸੋਧੋ",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "ਲਾਕ ਕਰੋ",
      "unlock": "ਅਨਲਾਕ ਕਰੋ",
      "lockAll": "ਸਭ ਲਾਕ ਕਰੋ",
      "unlockAll": "ਸਭ ਅਨਲਾਕ ਕਰੋ"
    },
    "sidebarLock": "ਸਾਈਡਬਾਰ ਨੂੰ ਖੁੱਲ੍ਹਾ ਰੱਖੋ",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "followUs": "",
    "discordChat": "",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": "",
    "preferences": "",
    "preferences_toolLock": "",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "",
    "midpointSnapping": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "ਕੈਨਵਸ ਰੀਸੈੱਟ ਕਰੋ",
    "exportJSON": "ਫਾਈਲ ਵਿੱਚ ਨਿਰਯਾਤ ਕਰੋ",
    "exportImage": "ਤਸਵੀਰ ਨਿਰਯਾਤ ਕਰੋ...",
    "export": "ਇਸ ਵਿੱਚ ਸਾਂਭੋ...",
    "copyToClipboard": "ਕਲਿੱਪਬੋਰਡ 'ਤੇ ਕਾਪੀ ਕਰੋ",
    "copyLink": "",
    "save": "ਮੌਜੂਦਾ ਫਾਈਲ ਵਿੱਚ ਸਾਂਭੋ",
    "saveAs": "ਇਸ ਵਜੋਂ ਸਾਂਭੋ",
    "load": "ਖੋਲ੍ਹੋ",
    "getShareableLink": "ਸਾਂਝੀ ਕਰਨ ਵਾਲੀ ਲਿੰਕ ਲਵੋ",
    "close": "ਬੰਦ ਕਰੋ",
    "selectLanguage": "ਭਾਸ਼ਾ ਚੁਣੋ",
    "scrollBackToContent": "ਸਮੱਗਰੀ 'ਤੇ ਵਾਪਸ ਸਕਰੋਲ ਕਰੋ",
    "zoomIn": "ਜ਼ੂਮ ਵਧਾਓ",
    "zoomOut": "ਜ਼ੂਮ ਘਟਾਓ",
    "resetZoom": "ਜ਼ੂਮ ਰੀਸੈੱਟ ਕਰੋ",
    "menu": "ਮੇਨੂ",
    "done": "ਹੋ ਗਿਆ",
    "edit": "ਸੋਧੋ",
    "undo": "ਅਣਕੀਤਾ ਕਰੋ",
    "redo": "ਮੁੜ-ਕਰੋ",
    "createNewRoom": "ਨਵਾਂ ਕਮਰਾ ਬਣਾਓ",
    "fullScreen": "ਪੂਰੀ ਸਕਰੀਨ",
    "darkMode": "ਡਾਰਕ ਮੋਡ",
    "lightMode": "ਲਾਇਟ ਮੋਡ",
    "systemMode": "",
    "zenMode": "ਜ਼ੈੱਨ ਮੋਡ",
    "objectsSnapMode": "",
    "exitZenMode": "ਜ਼ੈੱਨ ਮੋਡ 'ਚੋਂ ਬਾਹਰ ਨਿਕਲੋ",
    "cancel": "ਰੱਦ ਕਰੋ",
    "clear": "ਸਾਫ਼ ਕਰੋ",
    "remove": "ਹਟਾਓ",
    "embed": "",
    "submit": "ਜਮ੍ਹਾ ਕਰਵਾਓ",
    "confirm": "ਪੁਸ਼ਟੀ ਕਰੋ",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "ਇਹ ਸਾਰਾ ਕੈਨਵਸ ਸਾਫ ਕਰ ਦੇਵੇਗਾ। ਕੀ ਤੁਸੀਂ ਪੱਕਾ ਇੰਝ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    "couldNotCreateShareableLink": "ਸਾਂਝੀ ਕਰਨ ਵਾਲੀ ਲਿੰਕ ਨਹੀਂ ਬਣਾ ਸਕੇ।",
    "couldNotCreateShareableLinkTooBig": "ਸਾਂਝੀ ਕਰਨ ਵਾਲੀ ਲਿੰਕ ਨਹੀਂ ਬਣਾ ਸਕੇ: ਦ੍ਰਿਸ਼ ਬਹੁਤ ਵੱਡਾ ਹੈ",
    "couldNotLoadInvalidFile": "ਨਜਾਇਜ਼ ਫਾਈਲ ਲੋਡ ਨਹੀਂ ਕਰ ਸਕੇ",
    "importBackendFailed": "ਬੈਕਐੱਨਡ ਤੋਂ ਆਯਾਤ ਕਰਨ ਵਿੱਚ ਅਸਫਲ ਰਹੇ।",
    "cannotExportEmptyCanvas": "ਖਾਲੀ ਕੈਨਵਸ ਨੂੰ ਨਿਰਯਾਤ ਨਹੀਂ ਕਰ ਸਕਦੇ।",
    "couldNotCopyToClipboard": "ਕਲਿੱਪਬੋਰਡ 'ਤੇ ਕਾਪੀ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ।",
    "decryptFailed": "ਡਾਟਾ ਡੀਕਰਿਪਟ ਨਹੀਂ ਕਰ ਸਕੇ।",
    "uploadedSecurly": "ਅੱਪਲੋਡ ਸਿਰੇ-ਤੋਂ-ਸਿਰੇ ਤੱਕ ਇਨਕਰਿਪਸ਼ਨ ਨਾਲ ਸੁਰੱਖਿਅਤ ਕੀਤੀ ਹੋਈ ਹੈ, ਜਿਸਦਾ ਮਤਲਬ ਇਹ ਹੈ ਕਿ Excalidraw ਸਰਵਰ ਅਤੇ ਤੀਜੀ ਧਿਰ ਦੇ ਬੰਦੇ ਸਮੱਗਰੀ ਨੂੰ ਪੜ੍ਹ ਨਹੀਂ ਸਕਦੇ।",
    "loadSceneOverridePrompt": "ਬਾਹਰੀ ਡਰਾਇੰਗ ਨੂੰ ਲੋਡ ਕਰਨਾ ਤੁਹਾਡੀ ਮੌਜੂਦਾ ਸਮੱਗਰੀ ਦੀ ਥਾਂ ਲੈ ਲਵੇਗਾ। ਕੀ ਤੁਸੀਂ ਜਾਰੀ ਰੱਖਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
    "collabStopOverridePrompt": "ਇਜਲਾਸ ਨੂੰ ਰੋਕਣਾ ਪਿਛਲੀ ਲੋਕਲ ਸਾਂਭੀ ਡਰਾਇੰਗ ਦੀ ਥਾਂ ਲੈ ਲਵੇਗਾ। ਪੱਕਾ ਇੰਝ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?\n\n(ਜੇ ਤੁਸੀਂ ਆਪਣੀ ਲੋਕਲ ਡਰਾਇੰਗ ਨੂੰ ਬਰਕਰਾਰ ਰੱਖਣਾ ਚਾਹੁੰਦੇ ਹੋ ਤਾਂ ਇਹ ਕਰਨ ਦੀ ਬਜਾਏ ਬੱਸ ਆਪਣਾ ਟੈਬ ਬੰਦ ਕਰ ਦਿਉ।)",
    "imageDoesNotContainScene": "ਇਸ ਤਸਵੀਰ ਵਿੱਚ ਦ੍ਰਿਸ਼ ਦਾ ਕੋਈ ਵੀ ਡਾਟਾ ਨਜ਼ਰ ਨਹੀਂ ਆ ਰਿਹਾ। ਕੀ ਤੁਸੀਂ ਨਿਰਯਾਤ ਕਰਦੇ ਸਮੇਂ ਦ੍ਰਿਸ਼ ਨੂੰ ਮੜ੍ਹਣਾ ਸਮਰੱਥ ਕੀਤਾ ਸੀ?",
    "cannotRestoreFromImage": "ਇਸ ਤਸਵੀਰ ਫਾਈਲ ਤੋਂ ਦ੍ਰਿਸ਼ ਬਹਾਲ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ",
    "invalidSceneUrl": "ਦਿੱਤੀ ਗਈ URL 'ਚੋਂ ਦ੍ਰਿਸ਼ ਨੂੰ ਆਯਾਤ ਨਹੀਂ ਕਰ ਸਕੇ। ਇਹ ਜਾਂ ਤਾਂ ਖਰਾਬ ਹੈ, ਜਾਂ ਇਸ ਵਿੱਚ ਜਾਇਜ਼ Excalidraw JSON ਡਾਟਾ ਸ਼ਾਮਲ ਨਹੀਂ ਹੈ।",
    "invalidEncryptionKey": "ਇਨਕਰਿਪਸ਼ਨ ਕੁੰਜੀ ‌‌22 ਅੱਖਰਾਂ ਦੀ ਹੋਣੀ ਚਾਹੀਦੀ ਹੈ। ਲਾਇਵ ਸਹਿਯੋਗ ਬੰਦ ਹੈ।",
    "collabOfflineWarning": "ਕੋਈ ਇੰਟਰਨੈੱਟ ਕਨੈਕਸ਼ਨ ਨਹੀਂ ਹੈ\nਤੁਹਾਡੀਆਂ ਤਬਦੀਲੀਆਂ ਸਾਂਭੀਆਂ ਨਹੀਂ ਜਾਣਗੀਆਂ।",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "ਫਾਈਲ ਦੀ ਕਿਸਮ ਦਾ ਸਮਰਥਨ ਨਹੀਂ ਕੀਤਾ ਜਾਂਦਾ।",
    "imageInsertError": "ਚਿੱਤਰ ਸ਼ਾਮਲ ਨਹੀਂ ਜਾ ਸਕਿਆ, ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ...",
    "fileTooBig": "ਫਾਈਲ ਬਹੁਤ ਜ਼ਿਆਦਾ ਵੱਡੀ ਹੈ। ਵੱਧ-ਤੋਂ-ਵੱਧ ਪ੍ਰਵਾਨਤ ਅਕਾਰ {{maxSize}} ਹੈ।",
    "svgImageInsertError": "SVG ਤਸਵੀਰ ਸ਼ਾਮਲ ਨਹੀਂ ਕਰ ਸਕੇ। SVG ਮਾਰਕ-ਅੱਪ ਨਜਾਇਜ਼ ਲੱਗ ਰਿਹਾ ਹੈ।",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "ਚੋਣਕਾਰ",
    "lasso": "",
    "image": "ਤਸਵੀਰ ਸ਼ਾਮਲ ਕਰੋ",
    "rectangle": "ਆਇਤ",
    "diamond": "ਹੀਰਾ",
    "ellipse": "ਅੰਡਾਕਾਰ",
    "arrow": "ਤੀਰ",
    "line": "ਲਕੀਰ",
    "freedraw": "ਵਾਹੋ",
    "text": "ਪਾਠ",
    "lock": "ਡਰਾਇੰਗ ਤੋਂ ਬਾਅਦ ਵੀ ਚੁਣੇ ਹੋਏ ਸੰਦ ਨੂੰ ਸਰਗਰਮ ਰੱਖੋ ",
    "penMode": "ਪੈੱਨ ਮੋਡ - ਟੱਚ ਤੋਂ ਬਚਾਉਂਦਾ ਹੈ",
    "link": "",
    "eraser": "ਰਬੜ",
    "frame": "",
    "embeddable": "",
    "laser": "",
    "autoshape": "",
    "bucketfill": "",
    "hand": "",
    "extraTools": "",
    "convertElementType": ""
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "ਕੈਨਵਸ ਦੀਆਂ ਕਾਰਵਾਈਆਂ",
    "selectedShapeActions": "ਚੁਣੀ ਆਕ੍ਰਿਤੀ ਦੀਆਂ ਕਾਰਵਾਈਆਂ",
    "shapes": "ਆਕ੍ਰਿਤੀਆਂ"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "ਇੱਕ ਤੋਂ ਜ਼ਿਆਦਾ ਬਿੰਦੂਆਂ ਲਈ ਕਲਿੱਕ ਕਰਕੇ ਸ਼ੁਰੂਆਤ ਕਰੋ, ਇਕਹਿਰੀ ਲਕੀਰ ਲਈ ਘਸੀਟੋ",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "ਕਲਿੱਕ ਕਰਕੇ ਘਸੀਟੋ, ਪੂਰਾ ਹੋਣ 'ਤੇ ਛੱਡ ਦਿਉ",
    "text": "ਨੁਸਖਾ: ਤੁਸੀਂ ਚੋਣਕਾਰ ਸੰਦ ਰਾਹੀਂ ਕਿਤੇ ਵੀ ਡਬਲ-ਕਲਿੱਕ ਕਰਕੇ ਵੀ ਪਾਠ ਜੋੜ ਸਕਦੇ ਹੋ",
    "embeddable": "",
    "autoshape": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "toggleArrowhead": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "ਝਲਕ ਨਹੀਂ ਦਿਖਾ ਸਕਦੇ",
    "canvasTooBig": "ਸ਼ਾਇਦ ਕੈਨਵਸ ਬਹੁਤ ਜ਼ਿਆਦਾ ਵੱਡਾ ਹੈ।",
    "canvasTooBigTip": "ਨੁਸਖਾ: ਸਭ ਤੋਂ ਦੂਰ ਸਥਿੱਤ ਐਲੀਮੈਂਟਾਂ ਨੂੰ ਥੋੜ੍ਹਾ ਜਿਹਾ ਨੇੜੇ ਲਿਆ ਕੇ ਦੇਖੋ।"
  },
  "errorSplash": {
    "headingMain": "ਕੋਈ ਸਮੱਸਿਆ ਖੜ੍ਹੀ ਹੋਈ। <button>ਪੰਨਾ ਮੁੜ-ਲੋਡ</button> ਕਰਕੇ ਦੇਖੋ।",
    "clearCanvasMessage": "ਜੇ ਮੁੜ-ਲੋਡ ਕਰਨਾ ਕੰਮ ਨਾ ਕਰੇ, ਤਾਂ ਇਹ ਕਰਕੇ ਦੇਖੋ <button>ਕੈਨਵਸ ਸਾਫ ਕਰੋ।</button>",
    "clearCanvasCaveat": " ਇਹ ਸਾਰਾ ਕੰਮ ਗਵਾ ਦੇਵੇਗਾ ",
    "trackedToSentry": "ਸੂਚਕ {{eventId}} ਵਾਲੀ ਸਮੱਸਿਆ ਸਾਡੇ ਸਿਸਟਮ 'ਤੇ ਟਰੈਕ ਕੀਤੀ ਗਈ ਸੀ।",
    "openIssueMessage": "ਅਸੀਂ ਬੜੇ ਸਾਵਧਾਨ ਸੀ ਕਿ ਗਲਤੀ ਵਿੱਚ ਤੁਹਾਡੇ ਦ੍ਰਿਸ਼ ਦੀ ਜਾਣਕਾਰੀ ਸ਼ਾਮਲ ਨਾ ਕਰੀਏ। ਜੇ ਤੁਹਾਡਾ ਦ੍ਰਿਸ਼ ਨਿੱਜੀ ਨਹੀਂ ਹੈ ਤਾਂ ਇਸ 'ਤੇ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ ਜੀ <button>ਬੱਗ ਟਰੈਕਰ।</button>ਹੇਠਾਂ ਦਿੱਤੀ ਜਾਣਕਾਰੀ ਨੂੰ ਕਾਪੀ ਕਰਕੇ ਗਿੱਟਹੱਬ ਮੁੱਦੇ ਵਿੱਚ ਪੇਸਟ ਕਰਕੇ ਸ਼ਾਮਲ ਕਰੋ ਜੀ।",
    "sceneContent": "ਦ੍ਰਿਸ਼ ਦੀ ਸਮੱਗਰੀ:"
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "ਇਜਲਾਸ ਸ਼ੁਰੂ ਕਰੋ",
    "button_stopSession": "ਇਜਲਾਸ ਰੋਕੋ",
    "desc_inProgressIntro": "ਲਾਇਵ ਸਹਿਯੋਗ ਇਜਲਾਸ ਹੁਣ ਚੱਲ ਰਿਹਾ ਹੈ।",
    "desc_shareLink": "ਇਸ ਲਿੰਕ ਨੂੰ ਉਹਨਾਂ ਨਾਲ ਸਾਂਝਾ ਕਰੋ ਜਿਹਨਾਂ ਨਾਲ ਤੁਸੀਂ ਸਹਿਯੋਗ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ:",
    "desc_exitSession": "ਇਜਲਾਸ ਨੂੰ ਰੋਕਣਾ ਤੁਹਾਡਾ ਕਮਰੇ ਨਾਲੋਂ ਨਾਤਾ ਤੋੜ ਦੇਵੇਗਾ, ਪਰ ਤੁਸੀਂ ਸਥਾਨਕ ਪੱਧਰ 'ਤੇ ਦ੍ਰਿਸ਼ ਨਾਲ ਕੰਮ ਕਰਨਾ ਜਾਰੀ ਰੱਖ ਸਕੋਗੇ। ਇਹ ਧਿਆਨ 'ਚ ਰੱਖੋ ਕਿ ਇਹ ਬਾਕੀ ਲੋਕਾਂ ਨੂੰ ਪ੍ਰਭਾਵਿਤ ਨਹੀਂ ਕਰੇਗਾ , ਅਤੇ ਉਹ ਹਾਲੇ ਵੀ ਆਪਣੇ ਸੰਸਕਰਨ 'ਤੇ ਸਹਿਯੋਗ ਕਰਨ ਦੇ ਕਾਬਲ ਹੋਣਗੇ।",
    "shareTitle": "Excalidraw 'ਤੇ ਲਾਈਵ ਇਜਲਾਸ ਦਾ ਹਿੱਸਾ ਬਣੋ"
  },
  "errorDialog": {
    "title": "ਗਲਤੀ"
  },
  "progressDialog": {
    "title": "",
    "defaultMessage": ""
  },
  "exportDialog": {
    "disk_title": "ਡਿਸਕ ਵਿੱਚ ਸਾਂਭੋ",
    "disk_details": "ਦ੍ਰਿਸ਼ ਦਾ ਡਾਟਾ ਫਾਈਲ ਵਿੱਚ ਨਿਰਯਾਤ ਕਰੋ ਜਿੱਥੋਂ ਤੁਸੀਂ ਇਸਨੂੰ ਬਾਅਦ ਵਿੱਚ ਆਯਾਤ ਕਰ ਸਕਦੇ ਹੋ।",
    "disk_button": "ਫਾਈਲ ਵਿੱਚ ਸਾਂਭੋ",
    "link_title": "ਸਾਂਝੀ ਕਰਨ ਵਾਲੀ ਲਿੰਕ",
    "link_details": "ਸਿਰਫ ਦੇਖੇ-ਜਾਣ ਵਾਲੀ ਲਿੰਕ ਵਜੋਂ ਨਿਰਯਾਤ ਕਰੋ।",
    "link_button": "ਲਿੰਕ ਵਿੱਚ ਨਿਰਯਾਤ ਕਰੋ",
    "excalidrawplus_description": "ਆਪਣੇ ਦ੍ਰਿਸ਼ ਦੇ ਡਾਟੇ ਨੂੰ Excalidraw+ ਵਰਕਸਪੇਸ ਵਿੱਚ ਸਾਂਭੋ।",
    "excalidrawplus_button": "ਨਿਰਯਾਤ ਕਰੋ",
    "excalidrawplus_exportError": "ਇਸ ਸਮੇਂ Excalidraw+ ਵਿੱਚ ਨਿਰਯਾਤ ਨਹੀਂ ਕਰ ਸਕੇ..."
  },
  "helpDialog": {
    "blog": "ਸਾਡਾ ਬਲੌਗ ਪੜ੍ਹੋ",
    "click": "ਕਲਿੱਕ",
    "deepSelect": "",
    "deepBoxSelect": "",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "ਵਿੰਗਾ ਤੀਰ",
    "curvedLine": "ਵਿੰਗੀ ਲਕੀਰ",
    "documentation": "ਕਾਗਜ਼ਾਤ",
    "doubleClick": "ਡਬਲ-ਕਲਿੱਕ",
    "drag": "ਘਸੀਟੋ",
    "editor": "ਸੋਧਕ",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "ਕੋਈ ਸਮੱਸਿਆ ਲੱਭੀ? ਜਮ੍ਹਾਂ ਕਰਵਾਓ",
    "howto": "ਸਾਡੀਆਂ ਗਾਈਡਾਂ ਦੀ ਪਾਲਣਾ ਕਰੋ",
    "or": "ਜਾਂ",
    "preventBinding": "ਤੀਰ ਬੱਝਣਾ ਰੋਕੋ",
    "tools": "ਟੂਲ",
    "shortcuts": "ਕੀਬੋਰਡ ਸ਼ਾਰਟਕੱਟ",
    "textFinish": "ਸੋਧਣਾ ਮੁਕੰਮਲ ਕਰੋ (ਪਾਠ ਸੋਧਕ)",
    "textNewLine": "ਨਵੀਂ ਪੰਕਤੀ ਜੋੜੋ (ਪਾਠ ਸੋਧਕ)",
    "title": "ਮਦਦ",
    "view": "ਦਿੱਖ",
    "zoomToFit": "ਸਾਰੇ ਐਲੀਮੈਂਟਾਂ ਨੂੰ ਫਿੱਟ ਕਰਨ ਲਈ ਜ਼ੂਮ ਕਰੋ",
    "zoomToSelection": "ਚੋਣ ਤੱਕ ਜ਼ੂਮ ਕਰੋ",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": "",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "ਕੈਨਵਸ ਨੂੰ ਸਾਫ਼ ਕਰੋ"
  },
  "imageExportDialog": {
    "header": "ਤਸਵੀਰ ਨਿਰਯਾਤ ਕਰੋ",
    "label": {
      "withBackground": "ਪਿਛੋਕੜ",
      "onlySelected": "ਸਿਰਫ ਚੁਣੇ ਹੋਏ",
      "darkMode": "ਡਾਰਕ ਮੋਡ",
      "embedScene": "ਦ੍ਰਿਸ਼ ਮੜ੍ਹੋ",
      "scale": "ਸਕੇਲ",
      "padding": "ਪੈਡਿੰਗ"
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "PNG ਵਿੱਚ ਨਿਰਯਾਤ ਕਰੋ",
      "exportToSvg": "SVG ਵਿੱਚ ਨਿਰਯਾਤ ਕਰੋ",
      "copyPngToClipboard": "PNG ਨੂੰ ਕਲਿੱਪੋਬਰਡ ‘ਤੇ ਕਾਪੀ ਕਰੋ"
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": "ਗੱਤੇ 'ਤੇ ਕਾਪੀ ਕਰੋ"
    }
  },
  "encrypted": {
    "tooltip": "ਤੁਹਾਡੀ ਡਰਾਇੰਗਾਂ ਸਿਰੇ-ਤੋਂ-ਸਿਰੇ ਤੱਕ ਇਨਕਰਿਪਟ ਕੀਤੀਆਂ ਹੋਈਆਂ ਹਨ, ਇਸ ਲਈ Excalidraw ਦੇ ਸਰਵਰ ਉਹਨਾਂ ਨੂੰ ਕਦੇ ਵੀ ਨਹੀਂ ਦੇਖਣਗੇ।",
    "link": "Excalidraw ਵਿੱਚ ਸਿਰੇ-ਤੋਂ-ਸਿਰੇ ਤੱਕ ਇਨਕ੍ਰਿਪਸ਼ਨ 'ਤੇ ਬਲੌਗ ਸੰਪਾਦਨਾ"
  },
  "stats": {
    "angle": "ਕੋਣ",
    "shapes": "",
    "height": "ਉਚਾਈ",
    "scene": "ਦ੍ਰਿਸ਼",
    "selected": "ਚੁਣੇ",
    "storage": "ਸਟੋਰੇਜ",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "ਕੁੱਲ",
    "version": "ਸੰਸਕਰਨ",
    "versionCopy": "ਕਾਪੀ ਕਰਨ ਲਈ ਕਲਿੱਕ ਕਰੋ",
    "versionNotAvailable": "ਸੰਸਕਰਨ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
    "width": "ਚੌੜਾਈ"
  },
  "toast": {
    "copyStyles": "ਕਾਪੀ ਕੀਤੇ ਸਟਾਇਲ।",
    "copyToClipboard": "ਕਲਿੱਪਬੋਰਡ 'ਤੇ ਕਾਪੀ ਕੀਤਾ।",
    "copyToClipboardAsPng": "{{exportSelection}} ਨੂੰ ਕਲਿੱਪਬੋਰਡ 'ਤੇ PNG ਵਜੋਂ ਕਾਪੀ ਕੀਤਾ ({{exportColorScheme}})",
    "copyToClipboardAsSvg": "",
    "fileSaved": "ਫਾਈਲ ਸਾਂਭੀ ਗਈ।",
    "fileSavedToFilename": "{filename} ਵਿੱਚ ਸਾਂਭੀ",
    "canvas": "ਕੈਨਵਸ",
    "selection": "ਚੋਣ",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "ਪਾਰਦਰਸ਼ੀ",
    "black": "ਕਾਲੀ",
    "white": "ਸਫ਼ੈਦ",
    "red": "ਲਾਲ",
    "pink": "ਗੁਲਾਬੀ",
    "grape": "ਅੰਗੂਰੀ",
    "violet": "ਜਾਮਣੀ",
    "gray": "ਸੁਰਮਈ",
    "blue": "ਨੀਲਾ",
    "cyan": "ਫਿਰੋਜੀ",
    "teal": "ਟੀਲ",
    "green": "ਹਰਾ",
    "yellow": "ਪੀਲਾ",
    "orange": "ਸੰਤਰੀ",
    "bronze": "ਕਾਂਸੇਰੰਗਾ"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "",
      "menuHint": "ਨਿਰਯਾਤ, ਤਰਜੀਹਾਂ, ਭਾਸ਼ਾਵਾਂ, …"
    },
    "defaults": {
      "menuHint": "ਨਿਰਯਾਤ, ਤਰਜੀਹਾਂ, ਅਤੇ ਹੋਰ ਵੀ ਬਹੁਤ ਕੁਝ…",
      "center_heading": "ਡਾਇਆਗ੍ਰਾਮਾਂ। ਕੀਤੀਆਂ। ਸੁਖਾਲੀਆਂ।",
      "toolbarHint": "",
      "helpHint": "ਸ਼ਾਰਟਕੱਟ ਤੇ ਮਦਦ"
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "ਸਭ ਤੋਂ ਵੱਧ ਵਰਤੇ ਜਾਣ ਵਾਲੇ ਕਸਟਮ ਰੰਗ",
    "colors": "ਰੰਗ",
    "shades": "ਸ਼ੇਡਾਂ",
    "hexCode": "ਹੈਕਸ ਕੋਡ",
    "noShades": "ਇਸ ਰੰਗ ਦੀ ਕੋਈ ਸ਼ੇਡ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
